<template>
  <div>
    <div class="select-box">
      <select
        :name="this.field.metadata.fieldName"
        class="select"
        @change="updateDependency()"
        required
      >
        <option value="" disabled selected></option>
        <option
          v-for="(option, index) in this.field.metadata.options"
          :key="index"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
      <label class="select-label">
        {{ this.field.metadata.label }}
        <span class="required" v-if="this.field.metadata.required">*</span>
      </label>
      <br />
      <div class="hint" v-if="this.field.metadata.hint">
        <span v-html="this.field.metadata.hint"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { Bus } from "../main";

export default {
  name: "FormSelect",
  props: {
    field: {
      type: Object,
    },
  },
  methods: {
    updateDependency: function () {
      Bus.$emit("checkDependency");
    },
  },
  beforeDestroy() {
    // might be the parent of other component, so emit the event again to hide the component
    Bus.$emit("checkDependency");
  },
};
</script>

<style scoped>
.select-box {
  position: relative;
}

.select {
  border-radius: 4px;
  font-size: 14px;
  padding: 0.5rem;
  padding-left: 0;
  width: 100%;
  height: 2.5rem;
  margin-top: 0.2rem;
  box-sizing: border-box;
  border: 1px solid #000;
  background: #fff;
}

.select-label {
  position: absolute;
  transition: 0.2s;
  pointer-events: none;
  top: 0.65rem;
  left: 0.3rem;
  font-size: 16px;
  white-space: nowrap;
  background: #fff;
}

.select:focus ~ .select-label,
.select:valid ~ .select-label {
  top: -0.5rem;
  color: #0073c3;
  font-size: 14px;
  padding: 0 2px;
}

.select:focus {
  border: 2px solid #0073c3;
}

.hint {
  color: #8a8a8a;
  margin-left: 5px;
  margin-top: 5px;
}

.hint >>> * {
  margin-top: 0;
  margin-bottom: 0;
}

.required {
  color: #f00;
}
</style>